module.exports = __webpack_public_path__ + "static/media/ikebukuro-hanakawado-1.2d2ae5a4.jpg";